module.exports = __webpack_public_path__ + "img/set_theme_5.3cddc2f5.png";